// default = true allows for showing on the initial Profile Builder Questions list

module.exports = [
  {
    type: "scale0-5", 
    default: true,
    question: "Are you indoorsy or outdoorsy?", 
    leftText: "Very Outdoorsy", 
    rightText: "Very Indoorsy", 
    // in the format of an array because of the range slider component requirement
    // svelte-range-slider-pips
    selected: [0], 
    answers: [
      "Very Outdoorsy", 
      "Somewhat Outdoorsy", 
      "Neutral", 
      "Somewhat Indoorsy", 
      "Very Indoorsy"
    ], 
  },
  
  {
    type: "scale0-5", 
    default: true,
    question: "Do you consider yourself an introvert or extrovert?", 
    leftText: "Very Extroverted", 
    rightText: "Very Introverted", 
    selected: [0], 
    answers: [
      "Very Extroverted", 
      "Somewhat Extroverted", 
      "Neutral", 
      "Somewhat Introverted", 
      "Very Introverted"
    ], 
  },
  
  {
    type: "scale0-5", 
    default: true,
    question: "Do you identify liberal or conservative?", 
    leftText: "Very Liberal", 
    rightText: "Very Conservative", 
    selected: [0], 
    answers: [
      "Very Liberal", 
      "Somewhat Liberal", 
      "Centrist", 
      "Somewhat Conservative", 
      "Very Conservative"
    ], 
  },
  
  {
    type: "scale0-5", 
    default: true,
    question: "Are you religious?", 
    leftText: "Not Religious", 
    rightText: "Very Religious", 
    selected: [0], 
    answers: [
      "Not Religious", 
      "A Little Religious", 
      "Somewhat Religious", 
      "Definitely Religious", 
      "Very Religious"
    ], 
  },
  
  {
    type: "scale0-5", 
    default: true,
    question: "What percentage of a tip do you think service people deserve?", 
    leftText: "10%", 
    rightText: "30%", 
    selected: [0], 
    answers: [
      "10%", 
      "15%", 
      "20%", 
      "25%", 
      "30%"
    ], 
  },
  
  
]